// Algoritmo Módulo 11 da Receita Federal. Cada caractere é convertido pelo
// valor ASCII menos 48 (0-9 → 0-9, A-Z → 17-42) e multiplicado pelos pesos
// respectivos. CPF e CNPJ compartilham a etapa final (mod 11 → DV), mas
// usam pesos distintos.

/**
 * Calcula o dígito verificador de um CPF usando pesos lineares crescentes.
 *
 * @param {string} digits String com 9 dígitos (DV1) ou 10 dígitos (DV2).
 * @returns {number} Dígito verificador entre 0 e 9.
 */
export function cpfDigit(digits) {
  let sum = 0
  const { length } = digits

  for (let index = length - 1; index >= 0; index -= 1) {
    sum += (digits.charCodeAt(index) - 48) * (length - index + 1)
  }

  const mod = sum % 11
  return mod < 2 ? 0 : 11 - mod
}

/**
 * Calcula o dígito verificador de um CNPJ usando pesos cíclicos de 2 a 9.
 * Aceita as bases numérica e alfanumérica.
 *
 * @param {string} digits String com 12 caracteres (DV1) ou 13 (DV2).
 * @returns {number} Dígito verificador entre 0 e 9.
 */
export function cnpjDigit(digits) {
  let sum = 0
  let weight = 2

  for (let index = digits.length - 1; index >= 0; index -= 1) {
    sum += (digits.charCodeAt(index) - 48) * weight
    weight = weight === 9 ? 2 : weight + 1
  }

  const mod = sum % 11
  return mod < 2 ? 0 : 11 - mod
}
